import React from 'react';
import pick from 'lodash/pick';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import capitalize from 'lodash/capitalize';
import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import ProfilePage from 'pages/Profile/ProfilePage';
import {fetchUserProfileAction, startSaveProfileAction} from './actions';
import {formDataManager} from "hoc/formDataManager";
import AppContext from 'pages/AppContext';
import {isNoU} from "../../utils/DBUtils";
import profileFormConfig from './profileFormConfig';
import {getUserGroupName} from './selectors';

const mapStateToProps = (state) => {
    const {profile} = state.userProfile;
    const data = pick(profile, ['id', 'email', 'username', 'firstName', 'lastName']);
    const profileLoaded = Boolean(profile);

    const userGroupName = capitalize(getUserGroupName(state));

    return {
        data,
        userGroupName,
        profileLoaded,
        onlySaveUnchanged: false
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchProfile: fetchUserProfileAction,
    onSaveData: startSaveProfileAction
}, dispatch);

const ProfilePageContainerConnected = connect(mapStateToProps, mapDispatchToProps);

const ProfilePageLifecycle = lifecycle({
    componentWillMount() {
        if (!this.props.profileLoaded) {
            const userId = AppContext.persistentStore.getItem('userId');
            this.props.fetchProfile(userId);
        }
    }
});

const ProfilePageBasicInfoFormDataManager = formDataManager({
    lang: "en-US"
}, profileFormConfig);

const ProfilePageContainer = compose(
    ProfilePageContainerConnected,
    ProfilePageLifecycle,
    ProfilePageBasicInfoFormDataManager
)(ProfilePage);

export default ProfilePageContainer;



// WEBPACK FOOTER //
// ./public/pages/Profile/ProfilePageContainer.jsx